import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { useNavigate } from 'react-router-dom';

const SalesmanPortalProvider = (props) => {
  const api = new API();
  api.baseUrl = process.env.REACT_APP_BASE + "api/v1/";

  const [loginLoader, setLoginLoader] = useState(false);
  const [dashboardLoader, setDashboardLoader] = useState(false);
  const [billsLoader, setBillsLoader] = useState(false);
  const [billDetailsLoader, setBillDetailsLoader] = useState(false);

  const [dashboardData, setDashboardData] = useState({});
  const [myBills, setMyBills] = useState([]);
  const [billDetails, setBillDetails] = useState({});

  const [tableFilter, setTableFilter] = useState({
    page: 1, limit: 12, month: null, year: null
  });

  const loginSalesman = async (data, navigate) => {
    setLoginLoader(true);
    await api.create("salesmandashboard/login", data, (err, res) => {
      if (err) {
        Widget.showMessage("error", err?.response?.data?.message || "Login failed");
      } else {
        const token = res.data?.token || "";
        const info = res.data?.data || {};
        localStorage.setItem("salesman_token", token);
        localStorage.setItem("salesman_info", JSON.stringify(info));
        Widget.showMessage("success", "Login successful");
        navigate("/ambassador-portal/dashboard");
      }
      setLoginLoader(false);
    });
  };

  const getDashboardStats = async () => {
    setDashboardLoader(true);
    const apiWithSalesmanAuth = new API();
    apiWithSalesmanAuth.baseUrl = process.env.REACT_APP_BASE + "api/v1/";
    apiWithSalesmanAuth.token = localStorage.getItem("salesman_token");

    await apiWithSalesmanAuth.getAll("salesmandashboard/dashboard", {}, (err, res) => {
      if (res?.data?.status === 200) {
        setDashboardData(res.data.data);
      }
      setDashboardLoader(false);
    });
  };

  const getMyBills = async () => {
    setBillsLoader(true);
    const apiWithSalesmanAuth = new API();
    apiWithSalesmanAuth.baseUrl = process.env.REACT_APP_BASE + "api/v1/";
    apiWithSalesmanAuth.token = localStorage.getItem("salesman_token");

    await apiWithSalesmanAuth.getAll("salesmandashboard/bills", { ...tableFilter }, (err, res) => {
      if (res?.data?.status === 200) {
        setMyBills(res.data.data);
      }
      setBillsLoader(false);
    });
  };

  const getBillDetails = async (id) => {
    setBillDetailsLoader(true);
    const apiWithSalesmanAuth = new API();
    apiWithSalesmanAuth.baseUrl = process.env.REACT_APP_BASE + "api/v1/";
    apiWithSalesmanAuth.token = localStorage.getItem("salesman_token");

    await apiWithSalesmanAuth.getAll(`salesmandashboard/bill_details/${id}`, {}, (err, res) => {
      if (res?.data?.status === 200) {
        setBillDetails(res.data.data);
      }
      setBillDetailsLoader(false);
    });
  };

  return (
    <Context.Provider
      value={{
        ...props,
        loginLoader, loginSalesman,
        dashboardLoader, dashboardData, getDashboardStats,
        billsLoader, myBills, getMyBills, tableFilter, setTableFilter,
        billDetailsLoader, billDetails, getBillDetails
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default SalesmanPortalProvider;
